if (window.__POWERED_BY_QIANKUN__) {
  // 在子系统渲染前, 有些外部资源会把一些节点插入到主系统的body中, 由于 shadowroot 导致插入在主系统的节点没有样式
  // 此时子系统还没有渲染完成, 拿不到子系统 shadowroot 的根节点
  // 所以需要延迟事件直到子系统渲染完成后触发
  class DelayedEventBus {
    constructor() {
      this.listeners = new Map()
      this.pendingEvents = new Map()
    }

    emit(event, ...params) {
      if (this.listeners.has(event)) {
        const callbacks = this.listeners.get(event)
        callbacks.forEach((callback) => callback(...params))
      } else {
        if (!this.pendingEvents.has(event)) {
          this.pendingEvents.set(event, [])
        }
        this.pendingEvents.get(event).push(params)
      }
    }

    on(event, callback) {
      if (!this.listeners.has(event)) {
        this.listeners.set(event, [])
      }
      this.listeners.get(event).push(callback)

      if (this.pendingEvents.has(event)) {
        const pendingData = this.pendingEvents.get(event)
        pendingData.forEach((params) => callback(...params))
        this.pendingEvents.delete(event)
      }
    }

    off(event, callback) {
      if (this.listeners.has(event)) {
        const callbacks = this.listeners.get(event)
        const index = callbacks.indexOf(callback)
        if (index !== -1) {
          callbacks.splice(index, 1)
        }
      }
    }
  }
  window.delayedEventBus = new DelayedEventBus()
}
